export const DEFAULT_PROFILE_IMAGE = '/assets/profile.png'

export const getProfileImage = (image?: string | null) => {
  const normalizedImage = image?.trim()
  return normalizedImage || DEFAULT_PROFILE_IMAGE
}
